"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hair = void 0;
var AfroV2_1 = require("./AfroV2");
var Bangs2V2_1 = require("./Bangs2V2");
var BangsV2_1 = require("./BangsV2");
var BantuKnotsV2_1 = require("./BantuKnotsV2");
var BearV2_1 = require("./BearV2");
var Bun2V2_1 = require("./Bun2V2");
var Bun1V2_1 = require("./Bun1V2");
var BunV2_1 = require("./BunV2");
var BunsV2_1 = require("./BunsV2");
var Cornrows2V2_1 = require("./Cornrows2V2");
var CornrowsV2_1 = require("./CornrowsV2");
var Dreads1V2_1 = require("./Dreads1V2");
var Dreads2V2_1 = require("./Dreads2V2");
var FlatTopLongV2_1 = require("./FlatTopLongV2");
var FlatTopV2_1 = require("./FlatTopV2");
var GrayBunV2_1 = require("./GrayBunV2");
var GrayMediumV2_1 = require("./GrayMediumV2");
var GrayShortV2_1 = require("./GrayShortV2");
var HijabV2_1 = require("./HijabV2");
var LongAfroV2_1 = require("./LongAfroV2");
var LongBangsV2_1 = require("./LongBangsV2");
var LongCurlyV2_1 = require("./LongCurlyV2");
var LongV2_1 = require("./LongV2");
var Medium1V2_1 = require("./Medium1V2");
var Medium2V2_1 = require("./Medium2V2");
var Medium3V2_1 = require("./Medium3V2");
var MediumBangs2V2_1 = require("./MediumBangs2V2");
var MediumBangs3V2_1 = require("./MediumBangs3V2");
var MediumBangsV2_1 = require("./MediumBangsV2");
var MediumStraightV2_1 = require("./MediumStraightV2");
var Mohawk2V2_1 = require("./Mohawk2V2");
var MohawkV2_1 = require("./MohawkV2");
var NoHair1V2_1 = require("./NoHair1V2");
var NoHair2V2_1 = require("./NoHair2V2");
var NoHair3V2_1 = require("./NoHair3V2");
var PompV2_1 = require("./PompV2");
var Shaved1V2_1 = require("./Shaved1V2");
var Shaved2V2_1 = require("./Shaved2V2");
var Shaved3V2_1 = require("./Shaved3V2");
var Short1V2_1 = require("./Short1V2");
var Short2V2_1 = require("./Short2V2");
var Short3V2_1 = require("./Short3V2");
var Short4V2_1 = require("./Short4V2");
var Short5V2_1 = require("./Short5V2");
var Short6V2_1 = require("./Short6V2");
var TurbanV2_1 = require("./TurbanV2");
var Twists2V2_1 = require("./Twists2V2");
var TwistsV2_1 = require("./TwistsV2");
var Doctornurse1V2_1 = require("./Doctornurse1V2");
var Doctornurse2V2_1 = require("./Doctornurse2V2");
var Doctornurse3V2_1 = require("./Doctornurse3V2");
var HatbeanieV2_1 = require("./HatbeanieV2");
var HathipV2_1 = require("./HathipV2");
exports.Hair = {
    AfroV2: AfroV2_1.AfroV2,
    Bangs2V2: Bangs2V2_1.Bangs2V2,
    BangsV2: BangsV2_1.BangsV2,
    BantuKnotsV2: BantuKnotsV2_1.BantuKnotsV2,
    BearV2: BearV2_1.BearV2,
    Bun2V2: Bun2V2_1.Bun2V2,
    Bun1V2: Bun1V2_1.Bun1V2,
    BunV2: BunV2_1.BunV2,
    BunsV2: BunsV2_1.BunsV2,
    Cornrows2V2: Cornrows2V2_1.Cornrows2V2,
    CornrowsV2: CornrowsV2_1.CornrowsV2,
    Dreads1V2: Dreads1V2_1.Dreads1V2,
    Dreads2V2: Dreads2V2_1.Dreads2V2,
    FlatTopLongV2: FlatTopLongV2_1.FlatTopLongV2,
    FlatTopV2: FlatTopV2_1.FlatTopV2,
    GrayBunV2: GrayBunV2_1.GrayBunV2,
    GrayMediumV2: GrayMediumV2_1.GrayMediumV2,
    GrayShortV2: GrayShortV2_1.GrayShortV2,
    HijabV2: HijabV2_1.HijabV2,
    LongAfroV2: LongAfroV2_1.LongAfroV2,
    LongBangsV2: LongBangsV2_1.LongBangsV2,
    LongCurlyV2: LongCurlyV2_1.LongCurlyV2,
    LongV2: LongV2_1.LongV2,
    Medium1V2: Medium1V2_1.Medium1V2,
    Medium2V2: Medium2V2_1.Medium2V2,
    Medium3V2: Medium3V2_1.Medium3V2,
    MediumBangs2V2: MediumBangs2V2_1.MediumBangs2V2,
    MediumBangs3V2: MediumBangs3V2_1.MediumBangs3V2,
    MediumBangsV2: MediumBangsV2_1.MediumBangsV2,
    MediumStraightV2: MediumStraightV2_1.MediumStraightV2,
    Mohawk2V2: Mohawk2V2_1.Mohawk2V2,
    MohawkV2: MohawkV2_1.MohawkV2,
    NoHair1V2: NoHair1V2_1.NoHair1V2,
    NoHair2V2: NoHair2V2_1.NoHair2V2,
    NoHair3V2: NoHair3V2_1.NoHair3V2,
    PompV2: PompV2_1.PompV2,
    Shaved1V2: Shaved1V2_1.Shaved1V2,
    Shaved2V2: Shaved2V2_1.Shaved2V2,
    Shaved3V2: Shaved3V2_1.Shaved3V2,
    Short1V2: Short1V2_1.Short1V2,
    Short2V2: Short2V2_1.Short2V2,
    Short3V2: Short3V2_1.Short3V2,
    Short4V2: Short4V2_1.Short4V2,
    Short5V2: Short5V2_1.Short5V2,
    Short6V2: Short6V2_1.Short6V2,
    TurbanV2: TurbanV2_1.TurbanV2,
    Twists2V2: Twists2V2_1.Twists2V2,
    TwistsV2: TwistsV2_1.TwistsV2,
    Doctornurse1V2: Doctornurse1V2_1.Doctornurse1V2,
    Doctornurse2V2: Doctornurse2V2_1.Doctornurse2V2,
    Doctornurse3V2: Doctornurse3V2_1.Doctornurse3V2,
    HatbeanieV2: HatbeanieV2_1.HatbeanieV2,
    HathipV2: HathipV2_1.HathipV2
};
